import WebSocketsRepository from './WebSockets.repository';

export const webSocketsRepository = new WebSocketsRepository();
